<template>
  <div class="day">
    <div
      v-for="e in events"
      :key="e.id"
      class="event">

      <div class="time">
        <input-time
          noLabel
          inputName="eventTime"
          :inputValue="e.time"
          :sideValue="{id: e.id}"
          @fieldUpdate="setTime" />

      </div>

      <button
        @click="removeEvent(e.id)"
        class="delete">

        <icon name="times" />
      </button>
    </div>

    <div
      v-if="canAddEvent"
      class="add-event"
      @click="addEvent()">

      <button :class="{'disabled': !canAddEvent, 'add': true}">

        <icon name="plus" />
      </button>
    </div>
  </div>
</template>

<script>
import InputTime from '@/components/standard/input/InputTime'
import moment from 'moment'
import uuidv1 from 'uuid/v1'

export default {
  methods: {
    setTime (e) {
      let {value, extra} = e
      this.$emit('timeUpdate', {
        date: this.date,
        eventId: extra.id,
        time: value
      })
    },

    addEvent (params = {id: uuidv1(), time: {hh: '0', mm: '00', a: 'am'}}) {
      this.$emit('eventUpdate', {
        add: true,
        date: this.date,
        event: params
      })
    },

    removeEvent (id) {
      // Todo...
      this.$emit('removeEvent', {date: this.date, id})

      // let index = this.events.findIndex(e => e.id === id)
      // if (index > -1) {
      //   this.events.splice(index, 1)
      // }
    }
  },

  computed: {
    events () {
      return Object.values(this.dayEvents)
    },

    canAddEvent () {
      return this.max === null || this.events.length < this.max
    }
  },

  props: {
    date: {
      type: String,
      required: false,
    },
    max: {
      type: Number,
      required: false,
      default: null
    },
    dayEvents: {
      type: Object,
      required: false,
      default: () => {return {}}
    }
  },

  components: {
    'input-time': InputTime
  }
}
</script>

<style scoped>
.day .event, .add-event .add {
  display: flex;
  justify-content: center;
  align-items: center;
}

.add-event {
  width: 160px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 0;
  margin: 0 14px;
  cursor: pointer;
}

.day .label {
  font-weight: lighter;
  font-size: 10px;
}
.day {
  align-items: center;
  margin-bottom: 20px;
}
.disabled {
  cursor: not-allowed;
}

.event .delete, .add-event .add {
  background-color: transparent;
  border: 0;
  outline: 0;
  color: #F1A5AC;
  cursor: pointer;
  transition: all .3s;
}

.add-event .add {
  color: #7AC143;
}

.add-event .add:active {
  color: #43C169;
}

.event .delete:active {
  color: #C15043;
}


</style>



// WEBPACK FOOTER //
// src/components/service/campaignManager/channelSelectionParts/EventDay.vue?44cbbc9c